import Modal from '@/components/Modal/Modal'
import profileService from '@/services/profile.service'
import { CardType } from '@/types/card'
import { scryfallIdToImageURI } from '@/utils/helpers'

import styles from './AlternateArtModal.module.scss'

type Props = {
  card: CardType
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

const AlternateArtModal = ({ card, isOpen, setIsOpen }: Props) => {
  const handleArtSelection = async (url: string | null | undefined, scryfallId: string) => {
    if (!url) return console.warn(`No url for ${card.name}`)
    await profileService.update({ alternateArt: { [url]: scryfallId } })
    setIsOpen(false)
  }

  return (
    <>
      {isOpen && (
        <Modal
          className={styles.outerDialog}
          dialogClassName={styles.dialog}
          onHide={() => setIsOpen(false)}
          show={isOpen}
        >
          <Modal.Body>
            <div className={styles.cards}>
              {card.unique_artwork?.map(({ artist, collector_number, scryfall_id, set, set_name }, i) => (
                <div
                  className={styles.cardContainer}
                  key={i}
                  onClick={() => handleArtSelection(card.cards ? card.cards[0].url : card.url, scryfall_id)} // For Partner CardViews, edit the FIRST partner
                >
                  <div>
                    <img
                      alt={`${set} ${collector_number}`}
                      className={styles.card}
                      src={scryfallIdToImageURI(scryfall_id)}
                    />
                  </div>
                  <div className='text-center'>
                    <div className={styles.set}>{set_name}</div>
                    <div>{artist}</div>
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}

export default AlternateArtModal
